// extracted by mini-css-extract-plugin
export var container = "_lf-0";
export var dotAnimation = "_lf-2";
export var dotsLoading = "_lf-1";